import React, { useState } from "react";
import classnames from "classnames";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import styles from "./location-finder-result.module.scss";

const formatDay = name => name.charAt(0).toUpperCase() + name.slice(1, 3);

function LocationFinderResult({
  id,
  storeName,
  logo,
  address,
  distanceInMiles,
  openingHours,
  isAvailable,
  unavailabilityReason,
}) {
  const [showOpeningHours, setShowOpeningHours] = useState(false);

  const handleOpeningHoursToggle = () => {
    setShowOpeningHours(!showOpeningHours);
  };

  return (
    <div data-test="collection-location" data-test-id={id} className={styles["location-finder__container"]}>
      <div className={styles["location-finder__inner"]}>
        <div className={styles["location-finder__logo"]}>
          <img src={logo.icon} alt="" />
        </div>
        <div className={styles["location-finder__info"]}>
          <h3 className={styles["location-finder__name"]}>{storeName}</h3>
          <p className={styles["location-finder__address"]}>{Object.values(address).filter(Boolean).join(", ")}</p>
          <div className={styles["location-finder__opening-hours"]}>
            <h4 className={styles["location-finder__opening-hours-title"]}>
              <button
                type="button"
                className={classnames(styles["location-finder__opening-hours-button"], {
                  [styles["location-finder__opening-hours-button--open"]]: showOpeningHours,
                })}
                onClick={handleOpeningHoursToggle}
                data-test="opening-hours-toggle"
              >
                Opening times
              </button>
            </h4>
            {showOpeningHours && (
              <dl data-test="opening-hours-list" className={styles["location-finder__opening-hours-list"]}>
                {Object.entries(openingHours).map(([day, { openingTime, closingTime, comment }]) => (
                  <div className={styles["location-finder__opening-hours-list-item"]} key={day}>
                    <dt className={styles["location-finder__opening-hours-day"]}>{`${formatDay(day)}:`}</dt>
                    <dd
                      className={styles["location-finder__opening-hours-times"]}
                      data-test={`opening-hours-info-${day}`}
                    >
                      {openingTime && closingTime ? `${openingTime} – ${closingTime}` : comment}
                    </dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </div>
        <p className={styles["location-finder__distance"]}>{`${parseFloat(distanceInMiles).toFixed(1)} miles`}</p>
      </div>
      {!isAvailable && (
        <Message
          dataTest="message"
          type="information"
          title={unavailabilityReason}
          className={styles["location-finder__unavailability-message"]}
          whiteBackground
          wideTab
        />
      )}
    </div>
  );
}

export default LocationFinderResult;
